import { local } from 'common/js/storage';

// Return all notification IDs from local storage as array

const getDismissedNotificationIDs = () => {
  const notifications = local.getItem('STGDismissedNotifications');

  if (!notifications) return [];

  const parsed = JSON.parse(notifications);
  return Array.isArray(parsed) ? parsed : [];
};

// Add notifications ID to local storage

const storeNotificationID = (notificationID) => {
  const notificationArray = getDismissedNotificationIDs();

  if (notificationArray.indexOf(notificationID) === -1) {
    notificationArray.push(notificationID);
  }

  local.setItem('STGDismissedNotifications', JSON.stringify(notificationArray));
};

// Show notifications if their ID's aren't stored in local storage

const showNotifications = (notification) => {
  if (
    getDismissedNotificationIDs().indexOf(notification.dataset.notification) ===
    -1
  ) {
    notification.classList.remove('d-none');
    notification.setAttribute('aria-hidden', 'false');
  }
};

// Handler to hide notifications on click

const hideNotification = (notification) => {
  notification
    .querySelector('[data-notification-close]')
    .addEventListener('click', () => {
      storeNotificationID(notification.dataset.notification);
      notification.classList.add('d-none');
      notification.setAttribute('aria-hidden', 'true');
    });
};

// Loop through all elements, attach event handlers and un-hide them if they haven't been dismissed in the past

const init = () => {
  const notificationElements = document.querySelectorAll('[data-notification]');
  notificationElements.forEach((notification) => {
    showNotifications(notification);
    hideNotification(notification);
  });
};

document.addEventListener('DOMContentLoaded', init);
